<template>
  <el-container>
    <el-main style="height:100vh;padding:0px">
      <div  class="div-form">
        <el-form :label-position="labelPosition" label-width="80px" :rules="rules" size="mini" ref="formproductsn" :model="formproductsn">
<!--          <el-form-item label="用户id" required  prop="userAccountId">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.userAccountId" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
          <el-form-item label="产品"  prop="productType">
            <el-col :span="10">
              <el-select v-model='formproductsn.productType'  style='width:100%'  placeholder='请选择设备类型'>
                <el-option label="消防吊桶" value="消防吊桶"></el-option>
                <el-option label="光伏清洗" value="光伏清洗"></el-option>
                <el-option label="无线电检测盒子" value="无线电检测盒子"></el-option>
                <el-option label="六段抛投" value="六段抛投"></el-option>
                <el-option label="喊话器" value="喊话器"></el-option>
                <el-option label="破窗弹" value="破窗弹"></el-option>
                <el-option label="探照灯" value="探照灯"></el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="用户名"  prop="account">
            <el-col :span="10">
              <el-cascader
                style="width:100%"
                v-model="formproductsn.account"
                :options="this.options"
                @change="handleChange">
              </el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item label="天空端sn码"  v-if="this.formproductsn.productType=='消防吊桶'" prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="光伏清洗sn" v-else-if="this.formproductsn.productType=='光伏清洗'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="无线电检测盒子id" v-else-if="this.formproductsn.productType=='无线电检测盒子'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="六段抛投sn" v-else-if="this.formproductsn.productType=='六段抛投'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="喊话器sn" v-else-if="this.formproductsn.productType=='喊话器'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="破窗弹sn" v-else-if="this.formproductsn.productType=='破窗弹'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="探照灯sn" v-else-if="this.formproductsn.productType=='探照灯'"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
<!--          <el-form-item label="sn码2"  prop="sn2">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.sn2" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="sn码3"  prop="sn3">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.sn3" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="设备类型代码"  prop="productType">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.productType" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="设备类型代码"  prop="productType">-->
<!--            <el-col :span="4">-->
<!--          <el-select v-model="formproductsn.productType"   placeholder="请选择设备类型">-->
<!--             <el-option v-for="item in productTypes"-->
<!--            :key="item.label"-->
<!--            :label="item.label"-->
<!--            :value="item.label">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
          <el-form-item label="有效时间"  prop="deadLineDate">
            <el-col :span="10">
              <el-date-picker type="date" placeholder="选择日期" v-model="formproductsn.deadLineDate" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
          </el-form-item>
          <el-form-item label="产品唯一标识"  v-if="this.formproductsn.productType=='消防吊桶'?true:false" prop="udid">
            <el-col :span="10">
              <el-input v-model="formproductsn.udid"  placeholder="产品唯一标识" ></el-input>
            </el-col>
          </el-form-item>
<!--          <el-form-item label="设备权限"  prop="devicePerm">&ndash;&gt;-->
<!--            <el-col :span="10">-->
<!--              <el-select v-model="formproductsn.devicePerm" @change="$forceUpdate()" style="width:100%"  placeholder="设备权限">-->
<!--                <el-option v-for="item in devicePerms"-->
<!--                           :key="item.value"-->
<!--                           :label="item.label"-->
<!--                           :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
          <el-form-item>
            <el-col :span="10">
              <el-button type="primary" @click="save"  >保存</el-button>
              <el-button plain @click="reset">重置</el-button>
              <el-button plain @click="closed">返回</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../../utils/request'
export default {
  data () {
    var validatesn1 = (rule, value, callback) => {
      if (this.formproductsn.requesttype === 'update' && this.originalsn1 === value) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('id或sn不能为空'))
      } else {
        axios.get(`/data/bindsn/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn或id已在库中') {
            callback(new Error(res.data))
          } else {
            callback()
          }
        })
      }
    }

    var validateudid = (rule, value, callback) => {
      if (this.formproductsn.requesttype === 'update' && this.originaludid === value) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('udid不能为空'))
      } else {
        axios.get(`/data/bindsn/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn已在库中') {
            callback(new Error(res.data))
          } else {
            callback()
          }
        })
      }
    }
    return {
      formproductsn: {
        account: '',
        sn1: '',
        // sn2: '',
        // sn3: '',
        productType: '消防吊桶',
        deadLineDate: '',
        productId: 2,
        userAccountId: '',
        requesttype: '',
        udid: '',
        userId: 1
      },
      originalsn1: '',
      originaludid: '',
      // productTypes: [{value: 1, label: '无人机'}, {value: 2, label: '遥控器'}, {value: 4, label: '消防吊桶'}],
      filteredUsers: [{}],
      select_product_type: 0,
      rules: {
        sn1: [{ required: true, validator: validatesn1, trigger: 'change' }],
        udid: [{ required: true, validator: validateudid, trigger: 'change' }],
        deadLineDate: [
          { required: true, message: '请填截止时间', trigger: 'change' }
        ],
        productType: [
          { required: true, message: '请填产品', trigger: 'change' }
        ]
      },
      options: [],
      value: ['', ''],
      devicePerms: [ {value: 0, label: '超级管理员权限'}, {value: 1, label: '普通管理员权限'}, {value: 2, label: '受限权限'} ]
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    handleChange (val) {
      console.log('级联菜单', val[1])
      this.formproductsn.account = val[1]
      this.formproductsn.companyname = val[0]
    },
    changeaccount: function (e) {
      console.log('account', e)
    },
    save: function () {
      this.loading1 = true
      console.log(this.filteredUsers)

      if (this.formproductsn.account === '' && this.formproductsn.companyname === '') {
        this.formproductsn.userAccountId = ''
      } else {
        for (let user of this.filteredUsers) {
          console.log(user)
          // if (user.account === this.formproductsn.account) {
          //   this.formproductsn.userAccountId = user.id
          // }
          if (user.account === this.formproductsn.account && user.companyname === this.formproductsn.companyname) {
            this.formproductsn.userAccountId = user.id
          }
        }
      }
      if (this.formproductsn.productType === '消防吊桶') {
        this.formproductsn.productId = 2
      } else if (this.formproductsn.productType === '光伏清洗') {
        this.formproductsn.productId = 3
      } else if (this.formproductsn.productType === '无线电检测盒子') {
        this.formproductsn.productId = 4
      } else if (this.formproductsn.productType === '六段抛投') {
        this.formproductsn.productId = 5
      } else if (this.formproductsn.productType === '喊话器') {
        this.formproductsn.productId = 6
      } else if (this.formproductsn.productType === '破窗弹') {
        this.formproductsn.productId = 7
      } else if (this.formproductsn.productType === '探照灯') {
        this.formproductsn.productId = 8
      }
      let params = this.formproductsn
      console.log('addbucket-params', params)
      this.$refs.formproductsn.validate((valid) => {
        if (valid) {
          if (params.requesttype === 'update') {
            // this.$delete(params, 'requesttype')
            console.log(params)
            axios.put('/data/bindsn/update', params).then(res => {
              console.log('success')
              this.closed()
            })
          } else {
            axios.post('/data/bindsn/add', params).then(res => {
              console.log('success')
              this.closed()
            })
          }
        }
      }
      )
    },
    reset: function () {
      this.formproductsn.account = ''
      this.formproductsn.companyname = ''
      // this.formproductsn.sn1 = ''
      // // this.formproductsn.sn2 = ''
      // // this.formproductsn.sn3 = ''
      // this.formproductsn.productType = ''
      // this.formproductsn.deadLineDate = ''
      // this.formproductsn.productId = ''
      // this.formproductsn.devicePerm = ''
      // this.udid = ''
      // this.value = []
    },
    closed: function () {
      this.$router.push('/data/bucketproductsnbind')
    },
    loading: function () {
      this.formproductsn.userAccountId = this.$route.query.userAccountId === null ? '' : this.$route.query.userAccountId
      this.formproductsn.sn1 = this.$route.query.sn1
      this.originalsn1 = this.$route.query.sn1
      this.formproductsn.productType = this.$route.query.productType == null ? '消防吊桶' : this.$route.query.productType
      this.formproductsn.deadLineDate = this.$route.query.deadLineDate
      this.formproductsn.productId = this.$route.query.productId
      this.formproductsn.id = this.$route.query.id
      this.formproductsn.requesttype = this.$route.query.requesttype
      this.formproductsn.account = this.$route.query.account
      this.formproductsn.companyname = this.$route.query.companyname
      this.formproductsn.devicePerm = this.$route.query.devicePerm
      this.formproductsn.udid = this.$route.query.udid
      this.originaludid = this.$route.query.udid
      this.value[0] = this.$route.query.companyname
      this.value[1] = this.$route.query.account
      console.log('value', this.$route.query.companyname)
      axios.get(`/data/account/getAccount?accounttype=2`).then(res => {
        const result = JSON.stringify(res.data)
        this.options = JSON.parse(result)
      })
      this.methodToTrigger()
    },
    methodToTrigger: function () {
      axios.get(`/data/account/am?companyname=&pageNum=&pageSize=`).then(res => {
        this.filteredUsers = res.list
        this.total = res.total
      }).catch(error => {
        console.log('error', error)
      })
    }

  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .div-form{
    margin-top: 100px;
    margin-left: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/bucket/addbucketproductsn.vue